<div class="layout">
  <osp-whitelabeled-component
    #whitelabelRef
    [componentKey]="WhitelabeledComponentKey.SIDEBAR_MENU"
    [props]="sidebarProps"
    [defaultComponent]="SidebarComponent"
    class="layout__sidebar-container"
  />
  <div class="layout__right-column" [ngClass]="'layout__right-column--sb-' + $sidebarState()">
    <div class="layout__topbar-container">
      <osp-topbar></osp-topbar>
    </div>
    <div class="layout__content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
